import { Directive, HostListener, output } from '@angular/core';

@Directive({
    selector: '[aiContractNumber]',
    standalone: true,
})
export class ContractNumberDirective {
    public contractNumberError = output<any>();

    @HostListener('input', ['$event'])
    onInput(event: Event): void {
        const input = event.target as HTMLInputElement;
        const originalValue = input.value;
        const value = originalValue.replace(/\D/g, '').substring(0, 8);

        if (originalValue !== value) {
            const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
                window.HTMLInputElement.prototype,
                'value',
            )?.set;
            nativeInputValueSetter?.call(input, value);
            input.dispatchEvent(new Event('input', { bubbles: true }));
        }
    }
}
